export default "__VITE_ASSET__CDb7LOdn__"